export const useTransition = () => {
  const setStyles = (el: HTMLElement, styles: Partial<CSSStyleDeclaration>) => {
    Object.assign(el.style, styles)
  }

  const transitionBeforeEnter = (el: Element) => {
    setStyles(el as HTMLElement, {
      overflow: 'hidden',
      maxHeight: '0'
    })
  }

  const transitionEnter = (el: Element) => {
    setStyles(el as HTMLElement, {
      maxHeight: el.scrollHeight + 'px'
    })
  }

  const transitionAfterEnter = (el: Element) => {
    setStyles(el as HTMLElement, {
      overflow: '',
      maxHeight: ''
    })
  }

  const transitionBeforeLeave = (el: Element) => {
    setStyles(el as HTMLElement, {
      overflow: 'hidden',
      maxHeight: el.scrollHeight + 'px'
    })
  }

  const transitionLeave = (el: Element) => {
    setStyles(el as HTMLElement, {
      maxHeight: '0'
    })
  }

  return {
    transitionBeforeEnter,
    transitionEnter,
    transitionAfterEnter,
    transitionBeforeLeave,
    transitionLeave
  }
}
